import GalleryManager from "./GalleryManager";

export default function NumberCakeGalleryManager() {
    return (
        <GalleryManager
            endpoint="/admin/numbercake-gallery"
            title="Galerie Number Cake"
            description="Téléverse tes plus belles réalisations, elles s'afficheront en bas de l'onglet Number Cake sur la page Commander."
            testidPrefix="numbercake-gallery"
            itemLabel="Number Cake"
        />
    );
}
